enum ClaimPreferredResolutionEnum {
  REFUND_FULL = "REFUND_FULL",
  REFUND_PARTIAL = "REFUND_PARTIAL",
  REPLACEMENT = "REPLACEMENT",
  RETURN_ITEM = "RETURN_ITEM",
}

export default ClaimPreferredResolutionEnum;
